import { useEffect } from "react"
import AppRoutes from "./app/Routes"
import { useDeploymentNotifier } from "./app/hooks"
import { getTokenLocal } from "./helper/utils"

declare const window: {
  console: any;
} & Window;

function App() {
  const token = getTokenLocal()

  //? Removing logs in production

  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return;
    }

    const noop = () => { };
    [
      "assert",
      "clear",
      "count",
      "debug",
      "dir",
      "dirxml",
      "error",
      "exception",
      "group",
      "groupCollapsed",
      "groupEnd",
      "info",
      "log",
      "markTimeline",
      "profile",
      "profileEnd",
      "table",
      "time",
      "timeEnd",
      "timeline",
      "timelineEnd",
      "timeStamp",
      "trace",
      "warn",
    ].forEach((method: any) => {
      window.console[method] = noop;
    });
  }, []);

  // Connect to deployment SSE even for unauthenticated visitors
  useDeploymentNotifier(token)

  return (
    <AppRoutes />
  )
}

export default App
